
export default function modalHandler(_modalItem, _setModalItem, _showModal, _setShowModal) {
    _setModalItem(_modalItem)
    _setShowModal(_showModal)
}